import React, { Component } from "react";
import { Row, DatePicker, Table, Empty, Spin, Tag, message } from "antd";
import { FileExcelOutlined, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { DynamicCardForm, ButtonItem } from "../../../../Components/Items";
import { Tile, FilaTiles } from "../componentes/IndicadoresCMMS";
import { cmmsPost, fechaDiaPayload } from "../cmmsComun";

const { RangePicker } = DatePicker;
const km = (v) => (Number(v) || 0).toLocaleString("es-MX");

// Resumen como las hojas del C-LO-01: "Resumen semanal" (por semana: ingeniero, destinos, viajes,
// dias y km) y "KM Y DIAS VIAJADOS POR INGENIERO". El Excel esta en Reportes > Viajes.
// props: empleadoId (filtro de la pantalla), history, empresaId, headersToken
class ResumenViajesCMMS extends Component {
    state = { cargando: false, rango: [moment().startOf("month"), moment().endOf("month")], datos: null };

    componentDidMount() {
        this.consultar();
    }

    componentDidUpdate(prev) {
        if (prev.empleadoId !== this.props.empleadoId || prev.recarga !== this.props.recarga) this.consultar();
    }

    consultar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "reporteViajesCMMS", {
                desde: fechaDiaPayload(this.state.rango[0]),
                hasta: fechaDiaPayload(this.state.rango[1]),
                empleadoId: this.props.empleadoId,
            });
            if (res.data.success === 2) this.setState({ datos: res.data });
            else message.error(res.data.message || "No se pudo armar el resumen");
        } finally {
            this.setState({ cargando: false });
        }
    };

    render() {
        const d = this.state.datos;
        const columnas = [
            { title: "Ingeniero", dataIndex: "nombre", width: 220 },
            { title: "Destinos", dataIndex: "destinos", render: (v) => (v || []).map((x) => <Tag key={x}>{x}</Tag>) },
            { title: "Viajes", dataIndex: "viajes", width: 80, align: "right" },
            { title: "Días", dataIndex: "dias", width: 80, align: "right" },
            { title: "Km", dataIndex: "km", width: 110, align: "right", render: km },
        ];
        return (
            <Spin spinning={this.state.cargando}>
                <div className="cmms-viajes-barra">
                    <div className="cmms-viajes-filtro">
                        <span className="cmms-viajes-filtro-etiqueta">Periodo</span>
                        <RangePicker format="DD/MM/YYYY" allowClear={false} value={this.state.rango} onChange={(rango) => rango && this.setState({ rango }, this.consultar)} />
                    </div>
                    <div className="cmms-acciones">
                        <ButtonItem blanco lessTime icon={<SearchOutlined />} onClick={this.consultar}>
                            Actualizar
                        </ButtonItem>
                        <ButtonItem blanco lessTime icon={<FileExcelOutlined />} onClick={() => this.props.history.push("/panel/cmmsReportes/viajes")}>
                            Reporte en Excel
                        </ButtonItem>
                    </div>
                </div>
                {!d ? null : (
                    <>
                        <FilaTiles>
                            <Tile titulo="Viajes" valor={d.totales.viajes} detalle="En el periodo" />
                            <Tile titulo="Días de viaje" valor={d.totales.dias} detalle="Suma de los días de cada viaje" />
                            <Tile titulo="Km recorridos" valor={km(d.totales.km)} detalle="Ida y vuelta de cada viaje" />
                            <Tile titulo="Ingenieros que viajaron" valor={d.porIngeniero.length} />
                        </FilaTiles>
                        <Row gutter={14}>
                            <DynamicCardForm title="Km y días por ingeniero" xs={24}>
                                <div className="cmms-ayuda">Cada ingeniero suma los km completos de los viajes en que fue (como la hoja del C-LO-01).</div>
                                <Table size="small" rowKey="empleadoId" pagination={false} dataSource={d.porIngeniero} columns={columnas} locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin viajes en el periodo" /> }} />
                            </DynamicCardForm>
                            {d.semanas.map((s) => (
                                <DynamicCardForm key={s.desde} title={`Resumen semanal ${s.etiqueta}`} xs={24} lg={12}>
                                    <Table size="small" rowKey="empleadoId" pagination={false} dataSource={s.filas} columns={columnas} />
                                </DynamicCardForm>
                            ))}
                        </Row>
                    </>
                )}
            </Spin>
        );
    }
}

export default ResumenViajesCMMS;
